import { render, staticRenderFns } from "./DeliveryCollectionKpiPage.vue?vue&type=template&id=e6f82988&scoped=true&"
import script from "./DeliveryCollectionKpiPage.vue?vue&type=script&lang=js&"
export * from "./DeliveryCollectionKpiPage.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryCollectionKpiPage.vue?vue&type=style&index=0&id=e6f82988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f82988",
  null
  
)

export default component.exports